import React from "react";
import { connect } from "react-redux";
import SelectField from 'material-ui/SelectField';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import { Field, reduxForm } from "redux-form";

const styleCampos1 = {
	width: "59%",
	marginLeft: "240px",
	marginTop: "-8px"
}

const styleCampos2 = {
	width: "62%",
	marginTop: "-8px",
	marginLeft: "-28px"
}

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		regresar: (disp) => {
			dispatch({ "type": "EVENT_REGISTRO_DP-REGRESAR", "dispositivo": disp });
			dispatch({ "type": "REGISTRO_ASISTIDO_SIGUIENTE_ANTERIOR", "paso": 1 });
		}
	};
};

const validate = campos => {
	const errors = {};
	if (campos === undefined || campos.lada === undefined || campos.telefono === undefined) {
		console.log("");
	}
	else if ((campos.lada.length + campos.telefono.length) < 10) {
		errors.telefono = "Tu número de teléfono con lada incluida no debe ser menor a 10 dígitos.";
	}
	return errors;
};

const campo = ({ input, label, max, type, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				errorText={touched && error}
				floatingLabelText={label}
				fullWidth={true}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				type={type}
				onChange={(event) => { input.onChange(event) }}
				maxLength={max}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						handleKeyPress(input);
					}
				}}
			/>
		</MuiThemeProvider>
	);
};

const handleKeyPress = (input) => {
	const inputs = document.getElementsByTagName('input');
	const inputActual = input.name;
	for (let index = 0; index < inputs.length; index++) {
		if (inputActual === inputs[index].name) {
			switch (input.name) {
				case "telefono":
					console.log("telefono");
					document.getElementById(inputs[index].id).blur();
					document.getElementById("btn-continuar-inconvenientes").focus();
					break;
				case "lada":
					console.log("lada");
					document.getElementById(inputs[index + 1].id).focus();
					break;
				case "extension":
					console.log("extension");
					document.getElementById(inputs[index + 1].id).focus();
					break;				
				default:
					break;
			}
		}
	}
}

const campoSelect = ({ input, label, type, blur, name, meta: { touched, error }, children, ...custom }) => {
	return (
		<MuiThemeProvider>
			<SelectField
				{...input}
				floatingLabelText={label}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				onChange={(event, index, value) => { input.onChange(value); }}
				children={children}
				fullWidth={true}
				errorText={touched && error}
				menuStyle={{ left: '16px', top: '-16px' }}
				selectedMenuItemStyle={{ color: '#ff6b0b' }}
			/>
		</MuiThemeProvider>
	);
};

const campoSettings = {
	fontFamily: 'Open Sans',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#0C2040',
}

const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#FF6B0B',
}

class InconvenientesForm extends React.Component {

	state = {
		habilitarBoton: true
	}

	componentWillMount = () => {
		this.props.change("tipo", "fijo");
	}

	componentDidMount = () => {
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];
		if (url.includes("#!/gnp/registro-asistido")) {
			main.style.maxHeight = "100%";
			main.style.paddingBottom = "30px";
			main.style.overflow = "hidden auto";
		}
	}

	habilitaBoton = () => {
		const tipo = document.getElementsByName("tipo")[0].value;
		const lada = document.getElementsByName("lada")[0].value;
		const telefono = document.getElementsByName("telefono")[0].value;
		const telCompleto = lada + telefono;

		if (tipo === "" || lada === "" || telefono === "") {
			this.setState({ habilitarBoton: true });
		} else if (telCompleto.length < 10) {
			this.setState({ habilitarBoton: true });
		} else {
			this.setState({ habilitarBoton: false });
		}
	}

	aceptar = (_llamar) => {
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, llamar: _llamar }))();
	}

	regresar = () => {
		this.props.regresar(this.props.dispositivo);
	}

	render() {
		const { handleSubmit } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className="datos-wrap">

					<div className="txt-center">
						<div id="title-Registro">
							<label id="txt-Registro">Inconvenientes en tu registro</label>
							<br />
							<hr className="label-hr" />
						</div>
					</div>

					<div id="div-gral-return" style={{ marginTop: "40px" }}>
						<div className="div-return">
							<div className="flecha-naranja">
								<span className="material-icons bi bi-arrow-left" onClick={this.regresar}>arrow_back</span>
							</div>
							<div className="regresar">
								<label className="btn-return" onClick={this.regresar}>Regresar</label>
							</div>
							<div className="titulo1">
								<label className="txt-1">Ingresa la información solicitada</label>
							</div>
						</div>

						<label className="txt-3">Para poder procesar tu solicitud de registro, completa el siguiente formulario.</label>
						<br />
						<label className="txt-2" style={{ marginTop: "-24px" }}>DATOS DE CONTACTO</label>
						<hr className="label-hr2" />
					</div>

					<div className="row">
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={{ marginLeft: "-7px" }}>
								<div className="col-xs-12" id="datosStilosATipoTel" style={styleCampos1}>
									<Field
										name="tipo" label="Tipo de teléfono"
										className="col-xs-1"
										component={campoSelect}
										onChange={this.habilitaBoton}
									>
										<MenuItem value="" primaryText="" />
										<MenuItem value="fijo" primaryText="Fijo" />
										<MenuItem value="celular" primaryText="Celular" />
									</Field>
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
							<div className="row" style={{ marginLeft: "-7px" }}>
								<div className="col-xs-12" id="datosStilosAExtension" style={styleCampos2}>
									<Field
										name="extension" label="Extensión"
										component={campo} type="text" max="5"
										onChange={this.habilitaBoton}
									/>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-lg-6 col-sm-6 col-md-6  col-xs-12">
							<div style={{ marginLeft: "-7px" }} className="row">
								<div style={styleCampos1} className="col-xs-12" id="datosStilosALada" >
									<Field
										onChange={this.habilitaBoton}
										name="lada"
										label="Lada" max="4"
										component={campo} type="text"

									/>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-xs-12 col-sm-6  col-lg-6">
							<div className="row"
								style={{ marginLeft: "-7px" }}>
								<div className="col-xs-12"
									style={styleCampos2}
									id="datosStilosATel">
									<Field
										onChange={this.habilitaBoton}
										name="telefono" label="Teléfono"
										component={campo}
										type="text" max="8"

									/>
								</div>
							</div>
						</div>
					</div>
				</div>


				<div className="datos-wrap">
					<div className="row btn-bottom">
						<div className="col-md-6 col-sm-6 col-xs-12">
							<button
								className="orange-rectangle" disabled={this.state.habilitarBoton}
								onClick={this.aceptar.bind(this, false)} id="btn-continuar-inconvenientes">
								Continuar
							</button>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

InconvenientesForm = reduxForm({ form: "registro-asistido-inconvenientes", validate })(InconvenientesForm);

export default connect(mapState, mapDispatch)(InconvenientesForm);


// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/inconvenientesWeb.frm.js